import { Spacing } from 'zens-storybook'
import React, { Suspense } from 'react'
import { StyleSheet, View } from 'react-native'
import { AccessType } from 'zens-store'
import { useNumberParams, usePaginationParam, useSortParam } from 'zens-router'
import { BuildingTable, LayoutHeader, LocationHeader, LocationInfo } from '@dms/component'
import { usePermissions } from '@dms/hook'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    flex: 1,
    margin: Spacing.L,
  },
  buildings: {
    marginTop: Spacing.XL,
  },
})

const LocationDetail = () => {
  const [{ companyId, locationId }] = useNumberParams()
  const [pagination, setPagination] = usePaginationParam()
  const [sort, setSort] = useSortParam({ field: 'name', direction: 'asc' })
  const { hasPermission } = usePermissions(companyId)

  return (
    <View style={styles.container}>
      <Suspense fallback={<LayoutHeader.Skeleton breadcrumb title />}>
        <LocationHeader companyId={companyId} locationId={locationId} />
      </Suspense>
      <View style={styles.content}>
        <Suspense fallback={<LocationInfo.Skeleton />}>
          <LocationInfo companyId={companyId} locationId={locationId} />
        </Suspense>
        {hasPermission(AccessType.Read, 'building') && (
          <Suspense fallback={<BuildingTable.Skeleton style={styles.buildings} />}>
            <BuildingTable
              style={styles.buildings}
              companyId={companyId}
              locationId={locationId}
              pagination={pagination}
              onPaginationChange={setPagination}
              sort={sort}
              onSortChange={setSort}
            />
          </Suspense>
        )}
      </View>
    </View>
  )
}

export default LocationDetail
